import { IApplicationState } from '../../types/redux';

export const selectIsEmailConfirmed = (state: IApplicationState): boolean => state.isEmailConfirmed;
